import { Box, Dialog, IconButton, Stack, SxProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import React from "react";

import theme from "Theme/AppTheme";

interface DialogContainerProps {
    isOpen: boolean;
    onClose: () => void;
    icon?: React.ReactNode;
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
    hideCloseButton?: boolean;
    sx?: SxProps;
    id?: string;
}

export function DialogContainer({
    isOpen,
    onClose,
    icon,
    maxWidth = "sm",
    hideCloseButton,
    sx,
    id,
    children,
}: React.PropsWithChildren<DialogContainerProps>) {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth
            disableRestoreFocus
            PaperProps={{ sx: { borderRadius: 2 } }}
            sx={sx}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: theme.spacing(3, 3, 0, 3),
                }}
            >
                {icon ?? (
                    <ErrorIcon
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: 40,
                        }}
                    />
                )}

                {!hideCloseButton && (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        id={id ? `ays-dialog-close-${id}` : undefined}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                )}
            </Box>

            <Stack
                direction="column"
                rowGap={2}
                paddingInline={3}
                paddingBlock={2}
            >
                {children}
            </Stack>
        </Dialog>
    );
}
